import React, { PropsWithChildren } from 'react';
import { Box } from '@mui/material';

import PublicHeader from './Header';
import {
  contentContainerStyles,
  contentWrapperStyles,
  rootStyles,
} from './styles';

const PublicLayout = ({ children }: PropsWithChildren) => {
  return (
    <Box sx={rootStyles}>
      <PublicHeader />
      <Box sx={contentWrapperStyles}>
        <Box sx={contentContainerStyles}>{children}</Box>
      </Box>
    </Box>
  );
};

export default PublicLayout;
